export default "__VITE_ASSET__qZFj3Kqy__"